module.exports = __webpack_public_path__ + "static/media/seaGrass2.4995d9af.png";